import FileDownloadSection from "../../components/admin/FileDownloadSection";
import DeductionForm from "../../components/admin/DeductionForm";

const PaymentFile = () => {
  return (
    <div className="payment-file">
      <FileDownloadSection />
      <DeductionForm />
    </div>
  );
};

export default PaymentFile;
